import { blcpIdpClient, blcpIdpApiWrapper } from './blcp-idp-client'
import { createMethod } from './tools'

export const api = {
  blcpIdp: createMethod(blcpIdpClient, blcpIdpApiWrapper),
}
